export { default } from "./useSubmitPowerWordsQuestion";
